import React from 'react';
import { RecordColumn, RecordList } from 'components/record-shell/RecordList';
import { SupplierBank } from 'types/supplier';

interface SupplierBanksListProps {
  banks: SupplierBank[];
  handleDeleteBank(bank: SupplierBank, index: number): void;
  handleEditBank(bank: SupplierBank, index: number): void;
}

const columns: RecordColumn[] = [
  { id: 'bank', label: 'Banco' },
  { id: 'holder', label: 'Titular' },
  { id: 'agency', label: 'Agência' },
  { id: 'account', label: 'Conta' },
  { id: 'pix', label: 'Chave Pix' },
];

const SupplierBanksList: React.FC<SupplierBanksListProps> = ({ banks, handleDeleteBank, handleEditBank }) => (
  <RecordList
    columns={columns}
    rows={banks.map((bank, index) => ({
      key: bank.id || index,
      values: {
        bank: bank.bank_name,
        holder: bank.account_holder || '-',
        agency: bank.bank_agency || '-',
        account: bank.bank_account || '-',
        pix: bank.pix_key ? `${bank.pix_key_type ? `${bank.pix_key_type} · ` : ''}${bank.pix_key}` : '-',
      },
    }))}
    onEdit={index => handleEditBank(banks[index], index)}
    onDelete={index => handleDeleteBank(banks[index], index)}
  />
);

export default SupplierBanksList;
